<template>
  <section class="hbox stretch">
    <div class="content-header">      
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>会员</el-breadcrumb-item>
        <el-breadcrumb-item>储值卡管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content-main">
      <el-form :inline="true" size="medium">            
        <el-form-item>
          <el-button type="primary" size="small" class="el-icon-circle-plus-outline" v-on:click="Add" >新增</el-button>
        </el-form-item>
        <el-form-item >
          <el-input placeholder="名称" v-model="queryParam.name" size="small" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="Search"  size="small">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="businessCard" style="width: 100%">
        <el-table-column  fixed  prop="Name" :show-overflow-tooltip="true" label="名称" > </el-table-column>
        <el-table-column  prop="MerchantName" :show-overflow-tooltip="true" label="商家"> </el-table-column>
        <el-table-column  prop="Value"  label="储值" width="70"> </el-table-column>
        <el-table-column  prop="Price"  label="售价" width="70" > </el-table-column>
        <el-table-column  prop="RecommendConsumeReward"  label="推荐他人消费奖励">
          <template slot-scope="scope">
            <p>{{scope.row.RecommendConsumeReward}}%</p>            
          </template>
        </el-table-column>
        <el-table-column  fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click="Edit(scope.row.Id)" type="text" size="small">编辑</el-button>
            <el-button @click="Delete(scope.row.Id)" type="text" size="small">&nbsp; 删除 </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :hide-on-single-page="true"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryParam.pageIndex"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="queryParam.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="queryParam.totalCount">
      </el-pagination>
    </div>   
  </section>
</template>
<script  type='text/ecmascript-6'>
  export default {
    props:{
    },
    data (){
      return {
        businessCard:[],
        queryParam:{
          name:'',
          pageIndex:1,
          pagesize:10,
          totalCount:10,
          sort:'price asc',
        }
      }
    },
    computed:{
    },
    mounted(){
      if (this.$route.params.queryParam) {
        this.queryParam = this.$route.params.queryParam
      }
      this.GetDate();
    },
    methods:{     
      Search:function(){
        this.queryParam.pageIndex = 1;
        this.GetBusinessDate();
      },
      Add:function(){
        this.$router.push({
          name:'businessCardInfo',
          params:{
            Id:''
          }
        })
      },
      GetDate:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/MerchantCard/index',
          params: that.queryParam
        }).then(function (resp) {
          that.queryParam.totalCount = resp.data.totalCount
          that.businessCard = resp.data.businessCard
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      Edit(id){
        this.$router.push({
          name:'businessCardInfo',
          params:{
            Id:id,
            queryParam : this.queryParam
          }
        })
      },
      handleSizeChange(val) {
        this.queryParam.pagesize = val
        this.queryParam.pageIndex = 1
        this.GetDate()
      },
      handleCurrentChange(val) {
        this.queryParam.pageIndex = val
        this.GetDate()
      },
      Delete(id){
        this.$confirm('确定要删除该会员卡吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var that = this
          this.axios({
            method:'post',
            url:that.global.serverSrc + '/api/MerchantCard/Delete',
            data:{
              id: id
            }
          }).then(function (resp) {  
            if(resp.data.errorCode==0){              
              that.$message.success(resp.data.message);
              that.GetDate();
            }else {              
              that.$message.warning(resp.data.message);
            }
          }).catch(resp => {
            console.log('请求失败：' + resp.message + ',' + resp.stack)
          })
        }).catch(() => {
            
        });
      }
    },
    components:{    
       
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-header
  padding 24px
  border 1px solid #C0C4CC
.content-main
  padding 24px  
</style>